// SEO Schema Generators for Structured Data

export interface BreadcrumbItem {
  name: string;
  path: string;
}

export const generateBreadcrumbSchema = (items: BreadcrumbItem[], origin: string) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `${origin}${item.path}`
    }))
  };
};

export const generateMedicalWebPageSchema = (
  name: string,
  description: string,
  url: string
) => {
  return {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "name": name,
    "description": description,
    "url": url,
    "specialty": "Medical Education",
    "audience": {
      "@type": "MedicalAudience",
      "audienceType": "Medical Students"
    }
  };
};

export const generateEducationalApplicationSchema = (
  name: string,
  description: string,
  url: string
) => {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "applicationCategory": "EducationalApplication",
    "name": name,
    "description": description,
    "url": url,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "operatingSystem": "Web Browser"
  };
};

export const generateProductSchema = (
  name: string,
  description: string,
  price: string,
  currency: string = "USD"
) => {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": name,
    "description": description,
    "offers": {
      "@type": "Offer",
      "price": price,
      "priceCurrency": currency,
      "availability": "https://schema.org/InStock",
      "priceValidUntil": new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    }
  };
};

export const generateLearningResourceSchema = (
  name: string,
  description: string,
  url: string,
  educationalLevel: string = "Medical School"
) => {
  return {
    "@context": "https://schema.org",
    "@type": "LearningResource",
    "name": name,
    "description": description,
    "url": url,
    "educationalLevel": educationalLevel,
    "learningResourceType": "Practice Exam",
    "audience": {
      "@type": "EducationalAudience",
      "educationalRole": "Medical Student"
    }
  };
};

export const generateArticleSchema = (
  title: string,
  description: string,
  url: string,
  publishedDate?: string,
  modifiedDate?: string
) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "description": description,
    "url": url,
    "datePublished": publishedDate || new Date().toISOString(),
    "dateModified": modifiedDate || new Date().toISOString(),
    "author": {
      "@type": "Organization",
      "name": "QuickMedicalReview"
    }
  };
};

export const generateOrganizationSchema = (origin: string) => {
  return {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "QuickMedicalReview",
    "alternateName": "Medical Exam Prep Platform",
    "url": origin,
    "description": "Comprehensive medical exam preparation platform with MCQs, study notes, mock exams, and AI-powered learning tools for medical students.",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Support",
      "email": "support@quickmedicalreview.com"
    },
    "sameAs": []
  };
};
